import { makeResetStyles, tokens, shorthands } from '@fluentui/react-components';

export const useBackgroundChangeStyles = makeResetStyles({
  display: 'flex',
  flexDirection: 'row',
  height: 'calc(100%  - 8px)',
  '& .control-section': {
    maxWidth: '320px',
    backgroundColor: tokens.colorNeutralBackground1,
    boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.14), 0px 0px 2px 0px rgba(0, 0, 0, 0.12)',
    borderRadius: '8px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    ...shorthands.padding('12px', '0px'),
  },
  '& .back-to-adjust': {
    ...shorthands.padding('0px', '16px'),
    '& button': {
      paddingLeft: '0px',
      minWidth: 'unset',
    },
    '& span': {
      width: '10px',
      height: '10px',
    },
  },
  '& .background-change-tabs': {
    ...shorthands.padding('0px', '16px'),
    '& [role="tablist"]': {
      minWidth: '170px',
      flexWrap: 'wrap',
      display: 'flex',
    },
    '& [role="tablist"] button:first-of-type': {
      paddingLeft: '0px',
    },
  },
  '& .image-section': {
    display: 'flex',
    ...shorthands.flex(1),
    position: 'relative',
    paddingTop: '48px',
    '& .target-image-wrapper': {
      width: '100%',
      backgroundImage: 'linear-gradient(45deg, #EBEBEB 25%, transparent 25%), linear-gradient(-45deg, #EBEBEB 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #EBEBEB 75%), linear-gradient(-45deg, transparent 75%, #EBEBEB 75%)',
      backgroundSize: '40px 40px',
      backgroundPosition: '0px 0px, 0px 20px, 20px -20px, -20px 0px',
      backgroundColor: '#FAFAFA',
      position: 'relative',
      '& .loading-mask': {
        position: 'absolute',
        width: '100%',
        height: '100%',
        opacity: 0.4,
        backgroundColor: '#E6E6E6',
        backgroundImage: 'linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, #47CFFA 50%, #B47CF8 100%)',
        top: 0,
        left: 0,
      },
    },
    '& .notification-content': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      ...shorthands.gap('4px'),
    },
    '& .dismiss-icon': {
      color: tokens.colorStatusDangerForeground1,
    },
    '& .check-mark-icon': {
      color: '#107C10',
    },
    '& .spinner-icon': {
      width: '16px',
      animationDuration: '1s',
      animationIterationCount: 'infinite',
      animationTimingFunction: 'linear',
      animationName: [{
        from: { transform: 'rotate(0deg)' },
        to: { transform: 'rotate(360deg)' },
      }],
    },
  },
  '& .prompt-control': {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    ...shorthands.padding('0px', '16px'),
    '& .loading-section': {
      width: '100%',
      marginTop: '16px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      ...shorthands.gap('8px'),
      color: tokens.colorNeutralForeground3Hover,
    },
    '& .prompt-example': {
      '& .example-image-list-label': {
        marginTop: '11px',
        color: tokens.colorNeutralForeground3,
      },
    },
    '& .prompt-view-tabs': {
      marginTop: '16px',
      paddingTop: '16px',
      paddingBottom: '16px',
      ...shorthands.borderTop('1px', 'solid', 'rgba(224, 224, 224, 1)'),
    },
    '& .prompt-example-new': {
      marginTop: '16px',
      borderTop: '1px solid var(--Neutral-Stroke-2-Rest, rgba(224, 224, 224, 1))',
      '& .example-image-list-label': {
        marginTop: '0px !important',
        fontWeight: '600',
        fontSize: '14px',
        lineHeight: '19px',
        color: 'rgba(96, 94, 92, 1)',
        ...shorthands.padding('16px', '0px', '12px'),
      },
    },
    '& .background-change-prompt': {
      marginTop: '24px',
      width: '100%',
      '& .prompt-title': {
        fontSize: '14px',
        fontWeight: '600',
        marginBottom: '8px',
      },
      '& .prompt-editor': {
        position: 'relative',
        '& .prompt-textarea': {
          width: '100%',
          borderRadius: '8px',
          paddingBottom: '42px',
          paddingTop: '6px',
          ...shorthands.overflow('hidden'),
          '& textarea': {
            minHeight: '75px',
          },
          '&::after': {
            height: '4px',
            clipPath: 'none',
            backgroundColor: '#464feb',
            borderColor: '#464feb',
          },
        },
        '& .action-bar': {
          position: 'absolute',
          bottom: '12px',
          right: '12px',
        },
      },
      '& .prompt-editor-new': {
        '& .prompt-textarea': {
          width: '100%',
          borderRadius: '8px',
          backgroundColor: 'rgba(245, 245, 245, 1)',
          ...shorthands.border('0px'),
          ...shorthands.padding('8px', '16px'),
          ...shorthands.overflow('hidden'),
        },
        '& .disabled-prompt-textarea': {
          color: 'rgba(189, 189, 189, 1)',
        },
        '& textarea': {
          minHeight: '80px !important',
          ...shorthands.padding('0px'),
        },
        '&::after': {
          height: '2px',
          backgroundColor: 'linear-gradient(289.99deg, #BA6DF1 14.58%, #4B9DF5 86.51%) !important',
        },
      },
    },
  },
});
